import React from "react";

interface Props {
  variation: string;
  capitalGain: string;
}

const ZoneMetrics: React.FC<Props> = ({ variation, capitalGain }) => (
  <div className="grid grid-cols-2 gap-2 md:gap-3 mb-3 md:mb-6">
    <div className="bg-gray-100 rounded-xl p-3 md:p-4">
      <p className="text-sm md:text-base text-gray-500">Variación 6 meses</p>
      <p className="text-lg font-bold text-emerald-500">{variation}</p>
    </div>
    <div className="bg-gray-100 rounded-xl p-3 md:p-4">
      <p className="text-sm md:text-base text-gray-500">Plusvalía</p>
      <p className="text-lg font-bold text-gray-900">{capitalGain}</p>
    </div>
  </div>
);

export default ZoneMetrics;
